import { useEffect } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { API } from "../lib/constants";

export const Analytics = () => {
  const [s, setS] = useState(null);
  const location = useLocation();

  useEffect(() => {
    axios.get(`${API}/settings/public`).then(({ data }) => setS(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (s?.ga4_id && window.gtag) {
      window.gtag("event", "page_view", { page_path: location.pathname, page_title: document.title });
    }
  }, [location.pathname, s]);

  if (!s) return null;
  return (
    <Helmet>
      {s.gsc_verification && <meta name="google-site-verification" content={s.gsc_verification} />}
      {s.gtm_id && <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${s.gtm_id}');`}</script>}
      {s.ga4_id && <script async src={`https://www.googletagmanager.com/gtag/js?id=${s.ga4_id}`} />}
      {s.ga4_id && <script>{`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag('js',new Date());gtag('config','${s.ga4_id}',{send_page_view:false,anonymize_ip:true});`}</script>}
    </Helmet>
  );
};
